import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import jaJP from 'antd/es/locale/ja_JP';
import i18n from '@/i18n';

import useRootStore from '@/stores/rootStore';
import { RootProvider } from './contexts';
import router from './router';



const localeMap = {
  'zh_CN': zhCN,
  'en_US': enUS,
  'ja_JP': jaJP,
}

export function App() {
  const rootStore = useRootStore();
  const { language } = i18n
  return (
    <RootProvider value={rootStore}>
      <ConfigProvider theme={{ token: { colorPrimary: '#3096FF' } }} locale={localeMap[language as 'zh_CN' | 'en_US' | 'ja_JP']}>
        <RouterProvider router={router} />
      </ConfigProvider>
    </RootProvider>
  );
}

